import React, { useState } from "react";
import "./AdminLoginCard.scss";
import logo from "../../../../Assets/General/Img/logo_nets.svg";
import { Link } from "react-router-dom";

const AdminLoginCard = ({ login, err }) => {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [agreed, setAgreed] = useState(false);

  const handleLogin = () => {
    if (agreed && id && password) {
      login(+id, password);
    }
  };

  return (
    <div className="adminLoginCard_block">
      <img src={logo} alt="Logo" className="logo" />
      <h2>Вход в личный кабинет</h2>
      <div className="adminLoginCard_item">
        <input
          type="number"
          placeholder="ID"
          value={id}
          onChange={(e) => setId(e.target.value)}
          className="input"
        />
        <input
          type="password"
          placeholder="Пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="input"
        />
        <div className="agreement">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            id="agreement"
          />
          <label htmlFor="agreement" className="custom-checkbox-label">
            <span
              className={`custom-checkbox ${agreed ? "checked" : ""}`}
            ></span>
            <p>
              Я ознакомился и согласен с{" "}
              <Link to="/oferta" className="oferta-link" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                публичной офертой
              </Link>
            </p>
          </label>
        </div>
        <p className="error">{err}</p>
        <button
          onClick={handleLogin}
          disabled={!agreed || !id || !password}
          className="login-button"
        >
          Вход
        </button>
      </div>
    </div>
  );
};

export default AdminLoginCard;
